import { ReactNode, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import { NAVBAR } from '../../config';
import DashboardHeader from './header';
import Navbar from './navbar/Navbar';

import { useRouter } from 'next/router';
import useAuth from 'src/hooks/useAuth';
import useResponsive from 'src/hooks/useResponsive';
import Login from 'src/pages/auth/login';
const MainStyle = styled('main')(({ theme }) => ({
  flexGrow: 1,
  paddingLeft: '36px',
  paddingRight: '36px',
  paddingTop: '36px',
  paddingBottom: '48px',
  width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
  maxWidth: '1960px',
  transition: theme.transitions.create('margin-left', {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.down('md')]: {
    padding: '24px',
    paddingTop: '36px',
    width: '100%',
  },
}));

type Props = {
  children: ReactNode;
};

export default function DashboardLayout({ children }: Props) {
  const { isAuthenticated, isInitialized } = useAuth();
  const isTablet = useResponsive('down', 'md');

  const { pathname, push } = useRouter();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  useEffect(() => {
    if (requestedLocation && pathname !== requestedLocation) {
      setRequestedLocation(null);
      push(requestedLocation);
    }
  }, [pathname, push, requestedLocation]);

  if (!isInitialized) {
    // 認証確認するまではダッシュボードをchildrenは表示しない
    return (
      <Stack>
        <Stack direction="row">
          <DashboardHeader />
          <Navbar />
        </Stack>
      </Stack>
    );
  }

  if (!isAuthenticated) {
    // ログインしていない場合はログイン画面に飛ばす
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }
  // ここまでauthの認証

  if (isTablet) {
    return (
      <Stack>
        <Stack direction="row">
          <DashboardHeader />
          <Navbar />
        </Stack>
        <MainStyle>{children}</MainStyle>
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: { md: 1 },
      }}
    >
      <DashboardHeader />

      <Navbar />
      <MainStyle>{children}</MainStyle>
    </Box>
  );
}
